/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Dpa_DescriptionInputs */

const en_legal_dpa_description = /** @type {(inputs: Legal_Dpa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we handle your clients' personal data on your behalf.`)
};

const pl_legal_dpa_description = /** @type {(inputs: Legal_Dpa_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak przetwarzamy dane osobowe Twoich podopiecznych w Twoim imieniu.`)
};

/**
* | output |
* | --- |
* | "How we handle your clients' personal data on your behalf." |
*
* @param {Legal_Dpa_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const legal_dpa_description = /** @type {((inputs?: Legal_Dpa_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Dpa_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_legal_dpa_description(inputs)
	return en_legal_dpa_description(inputs)
});